module.exports = require('./helpers/bundle-url').getBundleURL('fHglS') + "logo-dark.eefe0b7f.svg";